import { merge, of } from "rxjs";
import { AjaxError } from "rxjs/ajax";
import { catchError } from "rxjs/operators";
import { errorActions } from "./action.js";
class ProtectEpicCreator {
  createEpic(epic) {
    return (action$, state$, dependencies) => epic(action$, state$, dependencies).pipe(
      catchError((err, source) => {
        let handledError = null;
        if (err instanceof AjaxError) {
          handledError = { error: err, type: "ajax", code: err.status };
        } else {
          handledError = { error: err, type: "middleware" };
        }
        const actions = [errorActions.error(handledError)];
        return merge(source, ...actions.map((action) => of(action)));
      })
    );
  }
}
export {
  ProtectEpicCreator
};
//# sourceMappingURL=protectEpicCreator.js.map
